import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { GetUrlApi } from '../Globales/VariableGlobales';
import { GetUserCookie } from '../Globales/Utilidades';
import swal from 'sweetalert';
import Popup from "reactjs-popup";

export class PopupAgregarGrupo extends Component {
    static displayName = PopupAgregarGrupo.name;


    stateInicial = {
        familias:[],
    }
    constructor(props) {
        super(props);
        this.state = this.stateInicial;
        this.TraerFamilias();
    }

    componentDidMount() {
        // this.setState(this.props.state);
    }

    Estilos = {
        ButtonStyleS:
        {
            'borderRadius': '10px',
            'height': '48px',
            'width': '55px',
            'border-color': 'cadetblue',
            'backgroundColor': '#28a745',
            'margin-top': '0.5%',
            'margin-right': '1%',
            'margin-left': '2%'
        },
    }

    async CrearGrupo() {
        var producto = {};
        producto.descripcion = document.getElementById('txtDescGrupo').value;
        if (String(producto.descripcion).trim() === '') {
            swal('La descripción no puede esta en blanco', {
                icon: "warning",
            });
            return;
        }
        producto.isHabilitado = true;
        producto.familiaID = document.getElementById('cboFamilias').value;
        producto.sucursalID = GetUserCookie().SucursalID;
        //producto.UsuIngreso = GetUserCookie().username;
        var respuesta = await fetch(GetUrlApi() + '/api/Grupos/', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(producto),
        });
        if (respuesta.ok) {
            const resp = await respuesta.json();
            if (resp.mensaje) {
                swal(resp.mensaje, {
                    icon: "error",
                })
                return;
            }

            swal({
                title: "Grupo creado con exito",
                icon: "success",
            }).then(() => {
                this.props.Recargar();
            })
        }
    }

    async TraerFamilias() {
        const sucursalUsuario = GetUserCookie().SucursalID;
        var respuesta = await fetch(GetUrlApi() + '/api/Familias?sucursalID=' + sucursalUsuario, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        if (respuesta.ok) {
            var datos = await respuesta.json();
            console.log(datos);
            this.setState({ familias: datos });
        }
    }


    render() {

        return (
            <Popup
                defaultOpen
                modal
                //contentStyle={}
                onClose={() => { this.props.CerrarModalMaster() }}
                closeOnDocumentClick>

                <center>
                    <table>
                        <tbody>
                            <tr>
                                <td>Descripción</td>
                                <td>
                                    <input className="form-control" id="txtDescGrupo" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <td>Familia</td>
                                <td>
                                    <select className="form-control" id="cboFamilias">
                                        {
                                            this.state.familias.map((familia) => {
                                                return (
                                                    <option value={familia.id}>{familia.descripcion}</option>
                                                    );
                                            })
                                        }
                                        
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <button onClick={() => { this.CrearGrupo() }} data-toggle="tooltip" data-placement="right" title="Listo" style={this.Estilos.ButtonStyleS}>
                        <i class="fa fa-check-square-o fa-2x text-white" aria-hidden="true"></i></button>
                </center>

            </Popup>
        );
    }
}
